import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { DateProvider } from "src/app/_models/DateProvider";
import { GetDateProvider } from "src/app/_store/date-provider/date-provider.actions";
import { selectGetDateProvider } from "src/app/_store/date-provider/date-provider.selector";
import { AppConstants } from "src/app/constants/constants";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  dateProvider$: Observable<DateProvider>;
  @Input() url: string;
  
  constructor(private store: Store, private router: Router) {}

  ngOnInit(): void {
    this.store.dispatch(GetDateProvider());

    this.dateProvider$ = this.store.select(selectGetDateProvider);
  }

  redirectToContactUs(): void {
    this.router.navigate([AppConstants.CONTACT_US_PAGE]);
  }

  redirectToPrivacyPolicy(): void {
    this.router.navigate([AppConstants.PRIVACY_POLICY_PAGE]);
  }

  redirectToCopyright(): void {
    this.router.navigate([AppConstants.COPYRIGHT_PAGE]);
  }

  redirectToAccessibility(): void {
    this.router.navigate([AppConstants.ACCESSIBILITY_PAGE]);
  }
}
